import { Link, NavLink } from "react-router-dom";

export function AdminPlansNav({ active }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/plans" },
    { key: "dealers", label: "Concesionarios", href: "/admin/plans/dealers" },
    { key: "features", label: "Matriz", href: "/admin/plans/features" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "dashboard"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
      <Link to="/admin/dealers/trials">Trials</Link>
    </nav>
  );
}

export function PlanFeatureCell({ value }) {
  if (value === true) return "Sí";
  if (value === false) return "No";
  if (value == null) return "Ilimitado";
  return String(value);
}

export function PlanActionBar({ dealerId, canManage, onAssign, onSuspend, onCancel }) {
  if (!canManage) return null;
  return (
    <div className="admin-console__header-actions" style={{ flexWrap: "wrap", gap: "0.5rem" }}>
      <button type="button" className="admin-btn admin-btn--primary" onClick={onAssign}>Asignar / cambiar plan</button>
      <button type="button" className="admin-btn" onClick={onSuspend}>Suspender</button>
      <button type="button" className="admin-btn" onClick={onCancel}>Cancelar plan</button>
      <Link className="admin-btn" to={`/admin/dealers/${dealerId}`}>Abrir concesionario</Link>
      <Link className="admin-btn" to={`/admin/dealers/${dealerId}/trial`}>Abrir trial</Link>
      <Link className="admin-btn" to={`/admin/dealers/${dealerId}/performance`}>Performance</Link>
    </div>
  );
}
